import { Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
    selector: 'app-item-exportacao',
    templateUrl: './item-exportacao.component.html',
    styleUrls: ['./item-exportacao.component.scss'],
  })
  export class ItemExportacaoComponent {

    @Input("itemLabel") itemLabel:string;

    @Input("itemIconClass") itemIconClass:string;
    @Input("itemIconContent") itemIconContent:string;

    @Output() onItemClick:EventEmitter<string> = new EventEmitter();

    clickHandler(){
        this.onItemClick.emit(this.itemLabel);
    }

  }


// WEBPACK FOOTER //
// ./src/app/components/exportar/itemExportacao/item-exportacao.component.ts